import store from '@/store'

export const mixinAuth = {
  computed: {
    userKey () {
      return store.state.auth.authUser.userKey
    },
    clientCd () {
      return store.state.auth.authUser.clientCd
    },
    isSamsungFire () {
      // 삼성화재 확인
      return this.clientCd === 'samsungfire'
    },
    isWhoyoumind () {
      // 트라이얼 고객사
      return this.clientCd === 'whoyoumind'
    },
    memberInfo () {
      return store.getters.member
    },
    memberGb () {
      return store.getters.memberGb
    },
  }
}
